import { differenceInYears } from 'date-fns'
import * as maybe from 'lib/maybe'

const haveGuardian = player => !!player.guardian

export function isAdult(dateOfBirth, referenceDate = new Date()) {
  return differenceInYears(referenceDate, dateOfBirth) >= 18
}

export function isMinor(dateOfBirth, referenceDate = new Date()) {
  return !isAdult(dateOfBirth, referenceDate)
}

export function playerIsAdult(player, referenceDate = new Date()) {
  return maybe
    .of(player.contact.dateOfBirth)
    .map(dob => isAdult(dob, referenceDate))
    .withDefault(!haveGuardian(player))
}

export function playerIsMinor(player, referenceDate = new Date()) {
  return maybe
    .of(player.contact.dateOfBirth)
    .map(dob => isMinor(dob, referenceDate))
    .withDefault(haveGuardian(player))
}

export function fullName({ firstName, lastName }) {
  return `${firstName} ${lastName}`
}

// Helpers for virtual `types` attribute on TeamPlayers
// ----------------------------------------------------

/**
 * Compute the `types` attribute for a TeamPlayer.
 * Expects `isCaptain` and `player` attributes to be set.
 * See `playerIsAdult` for attributes expected on `player`.
 */
export function teamPlayerTypes(teamPlayer, referenceDate = new Date()) {
  if (teamPlayer.isCaptain) {
    return ['Adult', 'Team Captain']
  }

  return [playerIsAdult(teamPlayer.player, referenceDate) ? 'Adult' : 'Junior']
}

/**
 * Accepts array of TeamPlayers.
 * Each TeamPlayer must have `isCaptain` attribute and `types` attribute set.
 * The `types` attribute can be computed via the `teamPlayerTypes` function in this file.
 */
export const sortTeamPlayersByType = teamPlayers =>
  [...teamPlayers].sort((a, b) => {
    if (a.isCaptain) return -1
    if (b.isCaptain) return 1
    if (a.types[0] === b.types[0]) return 0
    if (a.types[0] === 'Adult') return -1
    return 1
  })
